module.exports = __webpack_public_path__ + "img/V-45-ER-550-B.591b4172.png";